var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlamme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 96,
    viewBox: "0 0 80 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22C13.3 25.9 2.7 38.1 4 66 8.5 96.5 40 96 40 96s35.3-0.4 36-36S47 2 47 2s13.4 34-9 37C15.2 41.6 18 22 18 22ZM56 40s12.4 24-4 38c-3.2 3.7-22.9 8.6-28-4-5.2-15.2 7-18.9 12-19C57.4 54.4 56 40 56 40Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlamme);
export default __webpack_public_path__ + "static/media/flamme.63b856b818947b65026d2da8ca497578.svg";
export { ForwardRef as ReactComponent };